const ColumnEditable = class ColumnEditable {
    isEditable = (row, column, canAddAndEditRows) => {
        if (row.isRemoved) {
            return false;
        }

        if (row.isFromModel) {
            let notEdited = ['quantity', 'modulenumber', 'description', 'block', 'factorycost', 'totalfactorycost', 'final', 'margin', 'marginpercentage', 'price'];
            return !notEdited.includes(column.slug.toLowerCase()) && !column.readonly;
        }

        return !column.readonly || (canAddAndEditRows && (column.slug.toLowerCase() == 'price' || column.slug.toLowerCase() === 'factorycost'));
    }
}

export default new ColumnEditable()